import PropTypes from "prop-types";
import {sendSlackMessageTracked} from "../../../models/notifications";
import {PencilWriteIcon, PhoneAndDesktopIcon, TabGroupIcon, VerticalTabsIcon} from "../../../assets";

const posts = [
    {
        id: 1,
        title: 'Public Brand',
        blurb: "You've invested over $15k in social media or Google Ads and saw results. Rising costs are eating into your ROI.",
    },
    {
        id: 2,
        title: 'Dropshipping Store',
        blurb: "You're starting and swiftly scaling a store from scratch with a limited budget. Small team, less than 5 full-time employees.",

    },
    {
        id: 3,
        title: 'Acquired a Company',
        blurb: "You've just acquired a new company or product line and need to merge operations and capture its full value.",
    },
]

export default function FirefoxCardView(props) {
    return (
        <div className="pb-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto mt-8 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-10 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                    {posts.map((post) => (
                        <article
                            key={post.id}
                            className="relative ring-1 ring-white isolate flex flex-col justify-end overflow-hidden rounded-2xl px-8 pt-12 pb-8 sm:pt-8"
                        >
                            <div className="">
                                <img
                                    src={post.id === 1 ? VerticalTabsIcon: post.id === 2 ? PhoneAndDesktopIcon : TabGroupIcon}
                                    // src={PencilWriteIcon}
                                    // src="https://www.mozilla.org/media/img/firefox/whatsnew/whatsnew142/vertical-tabs-sticker-dark.svg"
                                />
                            </div>

                            <div className="custom-font font-semibold pt-4">
                                {post.title}
                            </div>

                            <div className="text-base ">
                                {post.blurb}
                            </div>


                            <div className="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm/6 text-gray-300">
                                {/*<time dateTime={post.datetime} className="mr-8">*/}
                                {/*    {post.date}*/}
                                {/*</time>*/}
                                {/*<div className="p-1 mt-6">*/}
                                {/*    <button*/}
                                {/*        type="submit"*/}
                                {/*        className="flex-none rounded-md ring-1 px-3.5 py-2.5 text-lg font-semibold shadow-xs hover:bg-gray-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white dark:shadow-none"*/}
                                {/*        onClick={() => {*/}
                                {/*            sendSlackMessageTracked(`🧪 Potential lead is clicking on the CTA for the activity ${post.title}`)*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        Learn more*/}
                                {/*    </button>*/}
                                {/*</div>*/}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </div>
    )
}


FirefoxCardView.propTypes = {
    title: PropTypes.string,
    blurb: PropTypes.string,
}


FirefoxCardView.defaultProps = {
    title: "Less clutter and more focus with vertical tabs",
    blurb: "Firefox’s new sidebar lets you move tabs to the side, pin key sites and keep your AI assistant handy.",
}